module.exports = __webpack_public_path__ + "img/10.b708f007.png";